import { render, staticRenderFns } from "./LoadSpinner.vue?vue&type=template&id=10c85991&"
import script from "./LoadSpinner.vue?vue&type=script&lang=js&"
export * from "./LoadSpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports